export default __webpack_public_path__ + "static/media/B+.40bcf82d.svg";